import * as T from '../Typography';
import colors from '../../theme/colors';
import successCheckIcon from '../assets/success-check.svg';
import errorSymbolIcon from '../assets/error-symbol.svg';
import alertIcon from '../assets/alert.svg';
import { Grid, Box } from '@mui/material';

const decideBackgroundColor = (type: string) => {
  switch (type) {
    case 'success':
      return colors.green.shades.shade50;
    case 'error':
      return colors.red.shades.shade50;
    case 'warning':
      return colors.yellow.shades.shade50;
    default:
      return colors.green.shades.shade50;
  }
};

const Layout = ({ children, type }) => (
  <Grid
    container
    flexWrap={'nowrap'}
    sx={{
      width: {
        xs: '100%',
        sm: '384px'
      }
    }}
    backgroundColor={decideBackgroundColor(type)}
    padding={2}
    mt={3}
    borderRadius={'8px'}
  >
    {children}
  </Grid>
);

const Notification: React.FC<NotificationProps> = ({ message, type }) => {
  if (type === 'success') {
    return (
      <Layout type={type}>
        <Box item mt={2} mr={2}>
          <img src={successCheckIcon} alt="success notification" />
        </Box>
        <Box item mt={2}>
          <T.TextSmallRegular color={colors.green.shades.shade800}>
            {message}
          </T.TextSmallRegular>
        </Box>
      </Layout>
    );
  }

  if (type === 'error') {
    return (
      <Layout type={type}>
        <Box item mt={2} mr={2}>
          <img src={errorSymbolIcon} alt="error notification" />
        </Box>
        <Box item mt={2}>
          <T.TextSmallRegular color={colors.red.shades.shade800}>
            {message}
          </T.TextSmallRegular>
        </Box>
      </Layout>
    );
  }

  if (type === 'warning') {
    return (
      <Layout type={type}>
        <Box item mt={2} mr={2}>
          <img src={alertIcon} alt="warning notification" />
        </Box>
        <Box item mt={2}>
          <T.TextSmallRegular color={colors.yellow.shades.shade800}>
            {message}
          </T.TextSmallRegular>
        </Box>
      </Layout>
    );
  }
};

export default Notification;
